import React from "react";
import { useTranslation } from "react-i18next";

export default function Privacy() {
  //const { t } = useTranslation();
  const t = (property) => {
    const json = {
        privacy: {
            title: "Politique de confidentialité",
            owner: {
            title: "Propriétaire de l'application",
            lines: [
                "patrickm.consulting",
                "31 avenue du clos-banderet",
                "74200 Thonon-les-bains",
                "France"
            ],
            emailLabel: "E-mail de contact",
            email: "apple@tapslide.app"
            },
            data: {
            title: "Types de données collectées, buts de la collecte",
            none: "Aucune donnée personnelle n’est collectée !",
            stats: "Nous ne collectons uniquement des données de statistique comme la version de l’application, la durée d’utilisation et la version du système d’exploitation, qui ne sont pas de nature personnelle et qui ne sont donc pas concernés par le RGPD."
            }
        }
    };

    return property.split('.').reduce((acc, key) => acc?.[key], json);
  }


  return (
    <div className="privacy-policy">
      <div className="container">
        <div className="privacy-content">
          <h1>{t('privacy.title')}</h1>
          
          <section>
            <h2>{t('privacy.owner.title')}</h2>
            <p>
              {t('privacy.owner.lines', { returnObjects: true }).map((line, idx) => (
                <span key={idx}>
                  {line}
                  <br />
                </span>
              ))}
              <br />
              {t('privacy.owner.emailLabel')}: <a href="mailto:apple@tapslide.app">{t('privacy.owner.email')}</a>
            </p>
          </section>
          
          <section>
            <h2>{t('privacy.data.title')}</h2>
            <p>{t('privacy.data.none')}</p>
            <p>{t('privacy.data.stats')}</p>
          </section>
        </div>
      </div>
    </div>
  );
}